import e from "react";
import { cls as a } from "../../../../helpers/cls.js";
import { Badges as A } from "../Badges/index.js";
import "@olxbr/ds-icons";
import "../../../Text/Text.js";
import { Labels as D } from "../Labels/index.js";
import "../LinkWrapper/index.js";
import { Location as I } from "../Location/index.js";
import { OldPrice as L } from "../OldPrice/index.js";
import { Price as n } from "../Price/index.js";
import { PriceInfo as M } from "../PriceInfo/index.js";
import { SellerDetails as S } from "../SellerDetails/index.js";
import { Subtitle as U } from "../Subtitle/index.js";
import { Title as $ } from "../Title/index.js";
import "../AdCardHead/index.js";
import "../AdCardFooter/index.js";
const c = _ref => {
  let {
    mode: t = "horizontal",
    isHighlight: s,
    title: p,
    subtitle: d,
    adDetails: r,
    priceInformation: h,
    price: l,
    oldPrice: _,
    badgeGroup: f,
    headBadge: E,
    onlineStatus: g,
    professionalAd: x,
    location: H,
    showLocationMapPin: b = !0,
    date: B,
    adUrl: v,
    adUrlTarget: u = "_blank",
    showHiddenBadgesCounter: w = !0,
    hiddenBadgesColor: C = "info",
    fixedHeightElements: i,
    titleID: N,
    isVerticalSlimCard: P,
    isMobile: o,
    width: m
  } = _ref;
  return e.createElement("div", {
    className: a("olx-ad-card__content", "olx-ad-card__content--".concat(t), s && "olx-ad-card__content--highlight", P && "olx-ad-card__content--vertical-slim"),
    "data-testid": "ds-adcard-content"
  }, e.createElement("div", {
    className: a("olx-ad-card__top", "olx-ad-card__top--".concat(t))
  }, e.createElement("div", {
    className: a("olx-ad-card__details-ads", "olx-ad-card__details-ads--".concat(t))
  }, e.createElement(U, {
    fixedHeightElements: i
  }, d), e.createElement($, {
    adUrl: v,
    titleID: N,
    adUrlTarget: u,
    mode: t
  }, p), t === "horizontal" && o && e.createElement(n, {
    priceMobile: !0
  }, l), e.createElement(D, {
    width: m,
    fixedHeightElements: i
  }, r), (t === "horizontal" && !o || t === "vertical" || o && (!d || !r)) && e.createElement(A, {
    headBadge: E,
    width: m,
    showHiddenBadgesCounter: w,
    hiddenBadgesColor: C,
    fixedHeightElements: i
  }, f)), e.createElement("div", {
    className: a("olx-ad-card__details-price--".concat(t))
  }, e.createElement(L, {
    mode: t,
    fixedHeightElements: i
  }, _), e.createElement(n, {
    fixedHeightElements: i
  }, l), e.createElement(M, {
    mode: t
  }, h))), e.createElement("div", {
    className: "olx-ad-card__bottom"
  }, e.createElement("div", {
    className: "olx-ad-card__bottom-content"
  }, e.createElement(S, {
    isProfessionalAd: x,
    isOnline: g,
    fixedHeightElements: i
  }), e.createElement(I, {
    mode: t,
    date: B,
    showLocationMapPin: b
  }, H))));
};
c.displayName = "AdCardBody";
export { c as AdCardBody };